module.exports = __webpack_public_path__ + "img/ar_ar.8ea86dc1.png";